/*  ===================================
 *  FREE SHIPPING TRESHOLD WIDGET
 *  - Simple widget that adds a progress bar indicating how far they are for free shipping
 *  ===================================
 */

(async function(w,d){
    const settings = {
        container: 'FSTContainer',
        progress_bar: 'FSTBar',
        message: 'FSTMessage',
        message_error: 'Please enter a target goal amount in the Theme Settings > Extras > Free Shipping Threshold'
    };
    let userLocation;

    if (Cookies.get('sl_geolocation')) {
        userLocation = JSON.parse(Cookies.get('sl_geolocation'));
    } else {
        userLocation = await getGeolocaton();
        Cookies.set('sl_geolocation',userLocation)
    }

    const container = d.getElementById(settings.container);
    let data;

    function initData() {
        const dataset = container.dataset.settings ?? new Object;
        let target;

        if (Object.keys(dataset).length === 0) return;
        data = JSON.parse(dataset);

        switch (userLocation.country) {
            case 'Australia':
                target = data.targets.AU ?? data.targets.default;
                break;
            case 'New Zealand':
                target = data.targets.NZ ?? data.targets.default;
                break;
            default:
                target = data.targets.default;
        }

        data.country = userLocation.country;
        data.target = target;
    }

    function fetchCartData() {
        fetch((window.theme.routes.cart ? window.theme.routes.cart : '/cart.js'), {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.json())
            .then(data => calculateShipping(data));
    }

    function renderElements() {
        const labelHTML = d.createElement('label')
        labelHTML.classList.add('visually-hidden')
        labelHTML.setAttribute('for', settings.progress_bar)
        labelHTML.textContent = 'Free shipping progress'

        const progressBarHTML = d.createElement('progress')
        progressBarHTML.id = settings.progress_bar
        progressBarHTML.setAttribute('max', 100)
        progressBarHTML.setAttribute('value', 0)
        progressBarHTML.dataset.target = data.target

        const progressBarWrapper = d.createElement('div')
        progressBarWrapper.classList.add('fst-progress-bar-wrapper')
        progressBarWrapper.dataset.target = data.target
        progressBarWrapper.appendChild(progressBarHTML)

        const messageHTML = d.createElement('div')
        messageHTML.id = settings.message
        messageHTML.classList.add('fst-message')

        container.appendChild(messageHTML);
        container.appendChild(labelHTML);
        container.appendChild(progressBarWrapper);
    }

    function calculateShipping(cartJson) {
        const target = data.target ? data.target : null;
        const cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price) / 100;
        const progress_value = (cart_total / target) * 100;
        const remaining = target - cart_total;
        let message = '';

        if (target) {
            // Set value of progress bar
            if (progress_value >= 100){
                d.getElementById(settings.progress_bar).setAttribute('value', 100);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', 100);
            }
            else {
                d.getElementById(settings.progress_bar).setAttribute('value', progress_value ? progress_value : 0);
                d.getElementById(settings.progress_bar).parentElement.setAttribute('value', progress_value ? progress_value : 0);
            }

            message =
                remaining >= target ? data.message_default.replace('[target]', `$${target}`) :
                    remaining <= 0 ? data.message_success : data.message_ongoing.replace('[remaining]', `$${remaining ? remaining.toFixed(2) : target}`);

        }
        else
            message = settings.message_error

        // Display message
        d.getElementById(settings.message).innerHTML = message;
    }

    function init() {
        if (!container) return;

        initData();
        renderElements();
        fetchCartData();

        // Listeners for product added and cart updates
        ['cart:updated', 'ajaxProduct:added'].forEach(evt =>
            d.addEventListener(evt, fetchCartData, false)
        );
    }

    init();
})(window, document);